import Graph from './Graph.view';

export default Graph;
